import { LockOpenIcon } from '@heroicons/react/24/outline';
import type { ToolManifest } from '../types';

const manifest: ToolManifest = {
  slug: 'loto-proseduru',
  href: '/araclar/loto-proseduru',
  title: 'Kilitleme ve Etiketleme Prosedürü Oluşturucu',
  shortLabel: 'Kilitleme ve Etiketleme',
  eyebrow: '6331 · 28628 (İş Ekipmanları) · EKED uygulaması (saha pratiği)',
  description:
    'Bakım, onarım, temizlik öncesi makine ve ekipmanların enerji izolasyon prosedürünü (EKED — Etiketle, Kilitle, Emniyete Al, Dene) imzaya hazır belge olarak oluşturur. 7 enerji kategorisi ve standart 10 adımlı prosedür tek formda.',
  bullets: [
    '7 enerji türü (elektrik, mekanik, hidrolik, pnömatik…)',
    'İzolasyon noktası + kilitleme + doğrulama',
    'Standart 10 adım prosedür şablonu',
    'İmzaya hazır PDF (3 yetkili imza + operatör beyanı)',
  ],
  audience: 'OSGB · iş güvenliği uzmanı · Bakım sorumlusu · Mühendis',
  icon: LockOpenIcon,
  mevzuat: [
    { no: '6331', ad: 'İş Sağlığı ve Güvenliği Kanunu', madde: 'Md 4, 16, 17' },
    { no: '28628', ad: 'İş Ekipmanlarının Kullanımında Sağlık ve Güvenlik Şartları Yönetmeliği' },
  ],
  imzaTipi: 'UCLU',
  raporlama: 'PDF',
  pdfEndpoint: '/api/loto/pdf',
  faqs: [
    {
      question: 'LOTO ve EKED aynı şey mi?',
      answer:
        'EKED (Etiketle, Kilitle, Emniyete Al, Dene) Türkiye iş güvenliği uygulamasında LOTO (Lock-Out / Tag-Out) için kullanılan Türkçe karşılıktır. Aynı süreci tanımlar: bakım/onarım öncesi enerjinin etiketlenmesi, kilitlenmesi, emniyete alınması ve sıfır enerji doğrulaması (test/dene).',
    },
    {
      question: 'Her çalışan kendi kilidini takmak zorunda mı?',
      answer:
        'Evet. EKED uygulaması (saha pratiği) ve uluslararası iyi uygulama (ANSI/ASSP Z244.1-2024, TS EN ISO 14118:2017) gereği bakım/temizlik yapan her çalışan kendi kişisel kilidini takmalı, kilidini sadece kendisi açmalıdır. Birden çok çalışan varsa çoklu kilit kapağı (lockout hasp) kullanılır.',
    },
  ],
  seo: {
    title: 'Kilitleme ve Etiketleme (LOTO) Prosedürü Oluşturucu (28628) | Riskmatik',
    description:
      '6331 + 28628 İş Ekipmanları Yönetmeliği uyumlu LOTO / EKED (Etiketle, Kilitle, Emniyete Al, Dene) prosedür oluşturucu. 7 enerji kategorisi, 10 adım, 3 yetkili imza, operatör beyanı, PDF çıktı. Ücretsiz.',
    keywords:
      'loto prosedürü, eked prosedürü, etiketle kilitle emniyete al dene, etiketleme kilitleme, enerji izolasyon, lock out tag out, bakım güvenliği, 28628 yönetmelik',
    canonicalPath: '/araclar/loto-proseduru',
    featureList: [
      "Elektrik, mekanik, hidrolik, pnömatik, termal, kimyasal ve yerçekimi/yay enerjileri için izolasyon planı",
      "Her enerji türü için izolasyon noktası, kilitleme yöntemi ve sıfır enerji doğrulaması",
      "Ekipman künyesi ve en fazla 15 operatör için ayrı imza satırı",
      "Kilitleme ekipmanı kontrol listesi",
      "10 adımlı kilitleme ve etiketleme prosedürü",
      "Hazırlayan, onaylayan ve bakım sorumlusu imza blokları olan A4 PDF",
      "Ücretsiz, kayıt gerektirmez",
    ],
    lastmod: '2026-08-08',
    priority: '0.85',
    changefreq: 'monthly',
  },
  order: 50,
  enabled: true,
  launchedAt: '2026-05-04',
  topics: ['loto', 'eked', 'etiketle-kilitle', 'emniyete-al-dene', 'lockout', 'tagout', 'enerji-izolasyon', 'elektrik-kesim', 'bakim-onarim', 'is-ekipmani', 'kilitleme', 'etiketleme', '28628', 'kesinti-prosedur'],
  intent: 'form',
  spamCapacity: 3,
  bridge: {
    href: '/isg-yazilimi',
    etiket: 'Bakım güvenliği ve enerji izolasyon süreçlerini dijital yönetin',
  },
};

export default manifest;
